import { ViewContext } from '../enums';
import { FilterFormREI } from '../interfaces/filter-form-rei';

export const DefaultReiFilterSchema = {
	Buildings: {
		total_building_count: {
			min: 0,
			max: 0,
		},
		total_building_gfa: {
			min: 0,
			max: 0,
		},
		total_building_footprint: {
			min: 0,
			max: 0,
		},
		average_building_gfa: {
			min: 0,
			max: 0,
		},
		average_building_far: {
			min: 0,
			max: 0,
		},
		average_floor_count: {
			min: 0,
			max: 0,
		},
		average_building_footprint: {
			min: 0,
			max: 0,
		},
		baseType: [],
		purpose: [],
	},
	SupplyAndDemand: {
		existing_residential_supply: {
			min: 0,
			max: 0,
		},
		existing_office_supply: {
			min: 0,
			max: 0,
		},
		existing_retail_supply: {
			min: 0,
			max: 0,
		},
		residential_supply_under_construction: {
			min: 0,
			max: 0,
		},
		office_supply_under_construction: {
			min: 0,
			max: 0,
		},
		retail_supply_under_construction: {
			min: 0,
			max: 0,
		},
		residential_occupancy: {
			min: 0,
			max: 0,
		},
		office_occupancy: {
			min: 0,
			max: 0,
		},
		retail_occupancy: {
			min: 0,
			max: 0,
		},
		allocated_plots_residential: {
			min: 0,
			max: 0,
		},
		allocated_plots_office: {
			min: 0,
			max: 0,
		},
		allocated_plots_retail: {
			min: 0,
			max: 0,
		},
		existing_supply_apartment: {
			min: 0,
			max: 0,
		},
		existing_supply_villa_th: {
			min: 0,
			max: 0,
		},
		apartment_supply_under_construction: {
			min: 0,
			max: 0,
		},
		villa_th_supply_under_construction: {
			min: 0,
			max: 0,
		},
		apartment_occupancy: {
			min: 0,
			max: 0,
		},
		villa_th_occupancy: {
			min: 0,
			max: 0,
		},
		existing_supply_hospitality: {
			min: 0,
			max: 0,
		},
		under_construction_supply_hospitality: {
			min: 0,
			max: 0,
		},
		existing_supply_luxury: {
			min: 0,
			max: 0,
		},
		under_construction_supply_luxury: {
			min: 0,
			max: 0,
		},
		existing_supply_upper_upscale: {
			min: 0,
			max: 0,
		},
		under_construction_supply_upper_upscale: {
			min: 0,
			max: 0,
		},
		existing_supply_upscale: {
			min: 0,
			max: 0,
		},
		under_construction_supply_upscale: {
			min: 0,
			max: 0,
		},
		existing_supply_upper_midscale: {
			min: 0,
			max: 0,
		},
		under_construction_supply_upper_midscale: {
			min: 0,
			max: 0,
		},
		existing_supply_midscale: {
			min: 0,
			max: 0,
		},
		under_construction_supply_midscale: {
			min: 0,
			max: 0,
		},
		existing_supply_economy: {
			min: 0,
			max: 0,
		},
		under_construction_supply_economy: {
			min: 0,
			max: 0,
		},
	},
	Rent: {
		rentType: [],
		developer: [],
		propertySubType: [],
		year: [],
		noOfBedrooms: [],
		volume: {
			min: 0,
			max: 0,
		},
		avg_price: {
			min: 0,
			max: 0,
		},
		avg_price_per_sqm: {
			min: 0,
			max: 0,
		},
	},
	Sales: {
		salesType: [],
		developer: [],
		propertySubType: [],
		year: [],
		noOfBedrooms: [],
		volume: {
			min: 0,
			max: 0,
		},
		avg_price: {
			min: 0,
			max: 0,
		},
		avg_price_per_sqm: {
			min: 0,
			max: 0,
		},
	},
};

export const reiFilterForm: FilterFormREI = {
	id: '',
	offset: 0,
	limit: 1000,
	label: ViewContext.City,
	current: {
		...DefaultReiFilterSchema,
	},
	previous: {
		...DefaultReiFilterSchema,
	},
};
